import Repository from './Repository'

const URL_GET_INFO = '/patients'
const URL_GET_SEIZURE = '/patients/seizures'
const URL_GET_VIDEOS = '/patients/videos'
const URL_GET_VIEWED_HISTORIES = '/patients/histories'
const URL_GET_SEIZURE_CHANGE_RATE = '/patients/seizure-change-rate'
const URL_SAVE_DR_SELECT_PATIENT = '/patients/dr-select-patients'
const URL_REGISTER_DR_CHILDREN_NOTE = '/patients/dr-children-note'
const URL_GET_BASIC_INFO = '/patients/basic-info'
const URL_REGISTER_DR_PATIENT_NAME = '/patients/dr-patient-name'

export default {
  getInfo (payload) {
    return Repository.get(URL_GET_INFO, payload)
  },
  getSeizures (payload, type) {
    if (type === 'one_time_access_key') {
      return Repository.get(URL_GET_SEIZURE, payload)
    }
    else {
      return Repository.get(`${URL_GET_SEIZURE}/${payload.params.childId}`, payload)
    }
  },
  getVideos (payload) {
    return Repository.get(URL_GET_VIDEOS, payload)
  },
  getViewedHistories () {
    const state = JSON.parse(localStorage.getItem('vuex'))
    if (state.auth.typeOfUser === 'pharmacy') {
      let params = {
        pharmacy_user_id: state.auth.doctorInfo.id
      }
      return Repository.get(URL_GET_VIEWED_HISTORIES, { params: params})
    }
    else {
      return Repository.get(URL_GET_VIEWED_HISTORIES, { params: {typeOfUser: state.auth.typeOfUser}})
    }
  },
  getInfoByChildId (childId) {
    const state = JSON.parse(localStorage.getItem('vuex'))
    let params = {
      hospital_master_id: state.auth.doctorInfo?.hospital_master_id || null,
    }
    if (state.auth.typeOfUser === 'pharmacy') {
      params.pharmacy_user_id = state.auth.doctorInfo.id
    }

    return Repository.get(`${URL_GET_INFO}/${childId}`, { params: params})
  },
  getVideosByChildId (payload) {
    const state = JSON.parse(localStorage.getItem('vuex'))
    return Repository.get(`${URL_GET_VIDEOS}/${payload.params.childId}`, { params: {
      typeOfUser: state.auth.typeOfUser,
      from_date: payload.params.from_date,
      to_date: payload.params.to_date,
      page: payload.params.page
    }})
  },
  getDataSeizureChangeRate (payload) {
    return Repository.get(`${URL_GET_SEIZURE_CHANGE_RATE}/${payload.params.childId}`, payload)
  },
  drSelectPatient (payload) {
    return Repository.post(`${URL_SAVE_DR_SELECT_PATIENT}/${payload.childId}`, payload)
  },
  getSleepData(payload) {
    let params = {
      from_date: payload.from_date,
      to_date: payload.to_date
    }
    if (payload.pharmacy_user_id) {
      params.pharmacy_user_id = payload.pharmacy_user_id
    }
    return Repository.get(`${URL_GET_SEIZURE}/${payload.childId}/seizures-graph-24hours`, { params: params})
  },
  registerDrChildrenNote (payload) {
    return Repository.post(`${URL_REGISTER_DR_CHILDREN_NOTE}/${payload.childId}`, payload)
  },
  getBasicInfoByChildId (childId) {
    const state = JSON.parse(localStorage.getItem('vuex'))
    if (state.auth.typeOfUser === 'pharmacy') {
      let params = {
        pharmacy_user_id: state.auth.doctorInfo.id
      }
      return Repository.get(`${URL_GET_BASIC_INFO}/${childId}`, { params: params})
    }
    else {
      return Repository.get(`${URL_GET_BASIC_INFO}/${childId}`)
    }
  },
  drPatientName (payload) {
    const state = JSON.parse(localStorage.getItem('vuex'))
    if (state.auth.typeOfUser === 'pharmacy') {
      payload.pharmacy_user_id = state.auth.doctorInfo.id
      return Repository.post(`${URL_REGISTER_DR_PATIENT_NAME}/${payload.childId}`, payload)
    }
    else {
      return Repository.post(`${URL_REGISTER_DR_PATIENT_NAME}/${payload.childId}`, payload)
    }
  }
}
